import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Form/form';
import { ASTERISK } from '../../helpers/htmlConstants';
import { css } from '@patternfly/react-styles';
import { ValidatedOptions } from '../../helpers/constants';
export var FormGroup = function FormGroup(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      label = _a.label,
      labelIcon = _a.labelIcon,
      _a$isRequired = _a.isRequired,
      isRequired = _a$isRequired === void 0 ? false : _a$isRequired,
      _a$validated = _a.validated,
      validated = _a$validated === void 0 ? 'default' : _a$validated,
      _a$isInline = _a.isInline,
      isInline = _a$isInline === void 0 ? false : _a$isInline,
      _a$hasNoPaddingTop = _a.hasNoPaddingTop,
      hasNoPaddingTop = _a$hasNoPaddingTop === void 0 ? false : _a$hasNoPaddingTop,
      helperText = _a.helperText,
      helperTextInvalid = _a.helperTextInvalid,
      helperTextIcon = _a.helperTextIcon,
      helperTextInvalidIcon = _a.helperTextInvalidIcon,
      fieldId = _a.fieldId,
      props = __rest(_a, ["children", "className", "label", "labelIcon", "isRequired", "validated", "isInline", "hasNoPaddingTop", "helperText", "helperTextInvalid", "helperTextIcon", "helperTextInvalidIcon", "fieldId"]);

  var validHelperText = typeof helperText !== 'string' ? helperText : React.createElement("div", {
    className: css(styles.formHelperText, validated === ValidatedOptions.success && styles.modifiers.success),
    id: "".concat(fieldId, "-helper"),
    "aria-live": "polite"
  }, helperTextIcon && React.createElement("span", {
    className: css(styles.formHelperTextIcon)
  }, helperTextIcon), helperText);
  var inValidHelperText = typeof helperTextInvalid !== 'string' ? helperTextInvalid : React.createElement("div", {
    className: css(styles.formHelperText, styles.modifiers.error),
    id: "".concat(fieldId, "-helper"),
    "aria-live": "polite"
  }, helperTextInvalidIcon && React.createElement("span", {
    className: css(styles.formHelperTextIcon)
  }, helperTextInvalidIcon), helperTextInvalid);

  var showValidHelperTxt = function showValidHelperTxt(validationType) {
    return validationType !== ValidatedOptions.error && helperText ? validHelperText : '';
  };

  return React.createElement("div", Object.assign({}, props, {
    className: css(styles.formGroup, className)
  }), label && React.createElement("div", {
    className: css(styles.formGroupLabel, hasNoPaddingTop && styles.modifiers.noPaddingTop)
  }, React.createElement("label", {
    className: css(styles.formLabel),
    htmlFor: fieldId
  }, React.createElement("span", {
    className: css(styles.formLabelText)
  }, label), isRequired && React.createElement("span", {
    className: css(styles.formLabelRequired),
    "aria-hidden": "true"
  }, ' ', ASTERISK)), ' ', React.isValidElement(labelIcon) && labelIcon), React.createElement("div", {
    className: css(styles.formGroupControl, isInline && styles.modifiers.inline)
  }, children, validated === ValidatedOptions.error && helperTextInvalid ? inValidHelperText : showValidHelperTxt(validated)));
};